import { render } from "./ScaleOneToTen.vue?vue&type=template&id=2f83632a"
import script from "./ScaleOneToTen.vue?vue&type=script&lang=js"
export * from "./ScaleOneToTen.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__